import { toast } from 'sonner';

/**
 * Kopiert einen Wert in die Zwischenablage und meldet Erfolg/Fehler per Toast.
 * `label` benennt den kopierten Wert im Erfolgs-Toast (z.B. "Fehler-Identifier kopiert").
 * Returns false, wenn die Clipboard-API fehlt/verweigert — für Aufrufer mit eigenem Fallback.
 */
export async function copyToClipboard(value: string, label: string): Promise<boolean> {
  try {
    await navigator.clipboard.writeText(value);
    toast.success(`${label} kopiert`);
    return true;
  } catch {
    toast.error('Kopieren fehlgeschlagen');
    return false;
  }
}
